import { TabPanelInner } from 'components/Tabs';
import AudioOnlySetting from 'features/room/settings/tabs/AudioOnlySetting';

const VideoTabWithoutPermissions = () => (
  <TabPanelInner>
    <AudioOnlySetting />
  </TabPanelInner>
);

export default VideoTabWithoutPermissions;
